import { useModalAction } from '@components/common/modal/modal.context'
import { UserContext } from '@contexts/user/user.context'
import { IUser } from '@contexts/user/user.utils'
import { useTranslation } from 'next-i18next'
import { useContext } from 'react'

const ProductRebates = ({ data }) => {
  const { t: translate } = useTranslation('pdp')
  const { user } = useContext(UserContext) as IUser
  const { openModal } = useModalAction()

  const openPdpPopup = () => {
    openModal('REBATE_PDP_POPUP', {
      user,
      gpo_collection: data?.gpo_collection,
    })
  }

  return (
    <div className="border p-3 my-4 font-sofia ">
      <p className="text-yellow font-semibold">
        {translate('rebateEligible')}:
        {user?.platform_id ? (
          <span className="text-brand-dark text-sm ">
            {' '}
            {translate('text-rebate-congrats')}
          </span>
        ) : (
          <span className="text-brand-dark  font-medium">
            {' '}
            {translate('cashBackMessage')}{' '}
            <span
              onClick={openPdpPopup}
              className="underline cursor-pointer text-brand"
            >
              {translate('cashBackLinkText')}
            </span>
          </span>
        )}
      </p>
    </div>
  )
}

export default ProductRebates
